import React, { useState } from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/icons";

import "./custom-accordion.scss";

const CustomAccordion = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`custom-accordion ${isExpanded ? "expanded" : ""}`}>
      <div className="accordion-summary" onClick={toggleAccordion}>
        <header className="accordion-header">{title}</header>
        <McIcon
          icon={isExpanded ? "chevron-up" : "chevron-down"}
          size="20"
          className="accordion-icon"
        />
      </div>
      {isExpanded && <div className="accordion-details">{children}</div>}
    </div>
  );
};

export default CustomAccordion;
